import React, { useContext } from 'react';
import { Context } from '@store/store';
import formatTimestamp from '@utils/formatTimestamp';
import {
  StyledBookmarkItem,
  StyledBookmarkItemPages,
  StyledBookmarkItemText,
  StyledBookmarkItemTimestamp,
} from './bookmark-item.styles';

const BookmarkItem = ({ page, text, ts }) => {
  const [, dispatch] = useContext(Context);
  return (
    <StyledBookmarkItem>
      <StyledBookmarkItemPages
        onClick={() => {
          dispatch({ type: 'SET_CURRENT_PAGE', payload: page });
          dispatch({ type: 'TOGGLE_MAIN_MENU_SIDEBAR' });
        }}
      >{`Стр. ${page + 1}`}</StyledBookmarkItemPages>
      <StyledBookmarkItemText>{text}</StyledBookmarkItemText>
      <StyledBookmarkItemTimestamp>
        {formatTimestamp(ts)}
      </StyledBookmarkItemTimestamp>
    </StyledBookmarkItem>
  );
};

export default BookmarkItem;
